import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToasterRoot } from '@/shared/components/feedback';
import { persistor, store } from '@/shared/store';
import { ThemeProvider } from '@/shared/theme/ThemeProvider';

/**
 * Proveedores globales: store → rehidratación → tema. El enrutador lo aporta `App` (RouterProvider) y
 * los avisos globales (`DisplayMessage`, diálogo de preferencias) viven dentro del router, en `RootLayout`.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          {children}
          <ToasterRoot />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}
